var AdspotType;
(function (AdspotType) {
  AdspotType["ADSPOT_1440x60_POS1"] = "adspot-1440x60-pos1";
  AdspotType["ADSPOT_728x90_POS1"] = "adspot-728x90-pos1";
  AdspotType["ADSPOT_300x250_POS1"] = "adspot-300x250-pos1";
  AdspotType["ADSPOT_1x11_POS1"] = "adspot-1x11-pos1";
  AdspotType["ADSPOT_1x11_HOMEPAGE"] = "adspot-1x11-homepage";
})(AdspotType || (AdspotType = {}));
export default AdspotType;